module.exports = {
  entry: './src/apps/solution-advisor/index.tsx',
  shortcode: 'solution-advisor',
  title: 'FlashSystem Solution Advisor',
  status: 'stable',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-solution-advisor-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'id',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    org: 'digitalsales', // to filter the widget
    brand: 'automation', // automation, dataai, security, sustainabilty, storage, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'solution-advisor', // the product name in the URL
    description: 'Allows users to determine a savings.',
    activatedCountryPages: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'id',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
